import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import toastr from 'toastr';
import getUserService from '~/services/userService';
import template from '~/templates/sidebar.handlebars';
import getReportCategoryService from '~/services/reportCategoryService';
import getReportSubCategoryService from '~/services/reportSubCategoryService';
import GeneralView from '~/generalView';
import getUtilsService from '~/services/utilsService';
import Settings from '~/settings.js';

Handlebars.registerHelper('or', function (value1, value2) {
	return value1 || value2;
});  

var SidebarView = GeneralView.View.extend({
	tagName: "div",
	className: 'sidebar',
	subCategories: null,
	subid: null,
	varsupandsubs: null,
	menuId: null,
	events: {
		'click .btn-logout': 'logout',
		'click #sidebar-menu a': 'sectionOpenClose',
		'click [data-action="logout"]': 'logout',
		'change .radiooption': 'changeradioopt',
		'change .radiooption2': 'changeradioopt2',
		'click #statsbtn' : 'showfilters',
		'click #userstrazgraph' : "hidefilters",
		'click #trazgraph' : 'gototrazgraph',
		'click #set' : 'setfilters',
		'change .radiooption4' : 'togglesubcats',
		'click .tittle-text': 'reloadhome',
		'click #footer1': 'reloadhome',
		'click #open_troubleshooting': 'clearTickets'
	},
	
	hidefilters: function(){
		$('#optionsforchart').hide();
		$('#containerradiofocatandsub').hide();
		$('#optionsforchartseparator').hide();
		$('.filterstittle').hide();
		$('#catscontainer').hide();
		$('#catsandsubcatscontainer').hide();
		$('#rangepicker').hide();
		$('#rangepicker2').hide();
		$('#rangepicker3').hide();
		$('#rangepicker2').hide();
		$('#set').hide();
		$('#statsbtn').show();
	},
	
	gototrazgraph: function(){
		location.href = "#graphs";
	},
	
	gototable: function(){
		var opt = Backbone.history.getFragment().substring(0, 6);
		if (opt == 'report') {
			var id = Backbone.history.getFragment().substring(7, Backbone.history.getFragment().length);
			location.href = "#tables?kind=report&id="+id;
		}
	},
	
	gototimeline: function(){
		var opt = Backbone.history.getFragment().substring(0, 6);
		if (opt == 'report') {
			var id = Backbone.history.getFragment().substring(7, Backbone.history.getFragment().length);
			location.href = "#timeline?kind=report&id="+id;
		}
	},
	
	reloadhome: function(){
		if(window.location.href == "http://localhost:3002/#personal" || window.location.href == "https://shogunmonitor.com/test/dashboard/#personal"){
			location.reload();
		}
	},
	
	clearTickets: function(){
		EventHub.trigger('clearTickets');
	},
	
	togglesubcats: function(e){
		var id = "."+e.currentTarget.value;
		this.subid = e.currentTarget.value;
		$(id).toggle('fast');
	},
	
	setfilters: function(e){
		var that = this;
		var selectedmonths = $('#monthscontainer').val();
		var selectedyears = $('#yearscontainer').val();
		var selecteddays = $('#dayscontainer').val();
		//RADIOOPT1
		if($("#radiooption1").is(':checked')){
			var n = selecteddays.indexOf("-");
			var m = selecteddays.length;
			var day1 = selecteddays.substring(0, n);
			var day2 = selecteddays.substring(n+1,m);
			day1 = day1.trim();
			day2 = day2.trim();
			var daynum1 = arrlang[lang]['daysx'].indexOf(day1);
			var daynum2 = arrlang[lang]['daysx'].indexOf(day2);
			var y = daynum1 +'-'+daynum2;
			if ($("#radiooption1").is(':checked') && $("#radiooption4").is(':checked')) {
				var selectedsupcats = [];
				$('.supertcatchckbx:checked').each(function() {
					var that = this;
					selectedsupcats.push($(that).val());
				});
				location.href = "#charts?"+y+"!"+selectedsupcats;
			}
			if ($("#radiooption1").is(':checked') && $("#radiooption5").is(':checked')) {
				var selectedsubcats = [];
				var x = this.subid;
				$('.subcatopt:checked').each(
					function() {
						var that = this;
						selectedsubcats.push($(that).val());
					}
				);
                var container = [] , container2 = [], container3 = [],container4 = [];
				for (var i = 0; i < this.varsupandsubs.length; i++) {
					if(this.varsupandsubs[i].supercatid==x){
						container=this.varsupandsubs[i];
					}
				}
				container2 = container.subcat;
				for (var i = 0; i < container2.length; i++) {
					for (var x = 0; x < selectedsubcats.length; x++) {
						if(container2[i].id == selectedsubcats[x]){
							container3.push(container2[i]);
						}
					}
				}
				for (var i = 0; i < container3.length; i++) {
					container4.push(container3[i].id);
				}
				location.href = "#charts?"+y+'$'+container4;
			}
			if ($("#radiooption1").is(':checked')  && $("#radiooption4").is(':checked')==false && $("#radiooption5").is(':checked')==false) {
				location.href = "#charts?"+y+"";
			}
		}
		//RADIOOPT2
		if($("#radiooption2").is(':checked')){
			$('#daypicker').val('');
			if($("#radiooption2").is(':checked') && $("#radiooption4").is(':checked')){
				var selectedsupcats = [];
				$('.supertcatchckbx:checked').each(
					function() {
						var that = this;
						selectedsupcats.push($(that).val());
					}
				);
				location.href = "#charts?"+selectedmonths+"!"+selectedsupcats;
			}
			if ($("#radiooption2").is(':checked') && $("#radiooption5").is(':checked')) {
				var selectedsubcats = [];
				var xt = this.subid;
				$('.subcatopt:checked').each(
					function() {
						var that = this;
						selectedsubcats.push($(that).val());
					}
				);
				var container = [] , container2 = [], container3 = [],container4 = [];
				for (var i = 0; i < this.varsupandsubs.length; i++) {
					if(this.varsupandsubs[i].supercatid==xt){
						container=this.varsupandsubs[i];
					}
				}
				container2 = container.subcat;
				for (var i = 0; i < container2.length; i++) {
					for (var xd = 0; xd < selectedsubcats.length; xd++) {
						if(container2[i].id == selectedsubcats[xd]){
							container3.push(container2[i]);
						}
					}
				}
				for (var i = 0; i < container3.length; i++) {
					container4.push(container3[i].id);
				}
				location.href = "#charts?"+selectedmonths+'$'+container4;
			}
			if ($("#radiooption2").is(':checked')  && $("#radiooption4").is(':checked')==false && $("#radiooption5").is(':checked')==false) {
				location.href = "#charts?"+selectedmonths+"";
			}
		}
		//RADIOOPT3
		if($("#radiooption3").is(':checked')){
			$('#daypicker').val('');
			if($("#radiooption3").is(':checked') && $("#radiooption4").is(':checked')){
				var selectedsupcats = [];
				$('.supertcatchckbx:checked').each(
					function() {
						var that = this;
						selectedsupcats.push($(that).val());
					}
				);
				location.href = "#charts?"+selectedyears+"!"+selectedsupcats;
			}
			if ($("#radiooption3").is(':checked') && $("#radiooption5").is(':checked')) {
				var selectedsubcats = [];
				var x = this.subid;
				$('.subcatopt:checked').each(
					function() {
						var that = this;
						selectedsubcats.push($(that).val());
					}
				);
				var container = [] , container2 = [], container3 = [],container4 = [];
				for (var i = 0; i < this.varsupandsubs.length; i++) {
					if(this.varsupandsubs[i].supercatid==x){
						container=this.varsupandsubs[i];
					}
				}
				container2 = container.subcat;
				for (var i = 0; i < container2.length; i++) {
					for (var x = 0; x < selectedsubcats.length; x++) {
						if(container2[i].id == selectedsubcats[x]){
							container3.push(container2[i]);
						}
					}
				}
				for (var i = 0; i < container3.length; i++) {
					container4.push(container3[i].id);
				}
				location.href = "#charts?"+selectedyears+'$'+container4;
			}
			if ($("#radiooption3").is(':checked')  && $("#radiooption4").is(':checked')==false && $("#radiooption5").is(':checked')==false){
				location.href = "#charts?"+selectedyears+"";;
			}
		}
		//RADIOOPT4 CATEGOERIES
		if ($("#radiooption4").is(':checked') && $("#radiooption1").is(':checked') == false && $("#radiooption2").is(':checked') == false && $("#radiooption3").is(':checked') == false && $("#radiooption5").is(':checked') == false ) {
			var selectedsupcats = [];
			$('.supertcatchckbx:checked').each(
				function() {
					var that = this;
					selectedsupcats.push($(that).val());
				}
			);
			location.href = "#charts?"+"supercategories"+selectedsupcats;
		}
		////RADIOOPT5 SUBCATEGORIES
		if ($("#radiooption5").is(':checked') && $("#radiooption1").is(':checked') == false && $("#radiooption2").is(':checked') == false && $("#radiooption3").is(':checked') == false  && $("#radiooption4").is(':checked') == false ) {
			var selectedsubcats = [];
			var x = this.subid;
			$('.subcatopt:checked').each(
				function() {
					var that = this;
					selectedsubcats.push($(that).val());
				}
			);
			var container = [] , container2 = [], container3 = [],container4 = [];
			for (var i = 0; i < this.varsupandsubs.length; i++) {
				if(this.varsupandsubs[i].supercatid==x){
					container=this.varsupandsubs[i];
				}
			}
			container2 = container.subcat;
			for (var i = 0; i < container2.length; i++) {
				for (var x = 0; x < selectedsubcats.length; x++) {
					if(container2[i].id == selectedsubcats[x]){
						container3.push(container2[i]);
					}
				}
			}
			for (var i = 0; i < container3.length; i++) {
				container4.push(container3[i].id);
			}
			location.href = "#charts?"+'subcategories'+container4;
		}
        ////RADIOOPT6 GENERAL CHART
		if ($("#radiooption6").is(':checked') && $("#radiooption1").is(':checked') == false && $("#radiooption2").is(':checked') == false && $("#radiooption3").is(':checked') == false  && $("#radiooption4").is(':checked') == false && $("#radiooption5").is(':checked') == false ) {
			location.href = "#charts";
		}
	},
	
	setfilters2: function(){
		this.$el.find('#containerradiofocatandsub').show();
	},
	
    showfilters: function(){
		var permissions = getUtilsService.getprofilepermissions();
		this.$el.find('#optionsforchart').show();
		this.$el.find('#containerradiofocatandsub').show();
		this.$el.find('#optionsforchartseparator').show();
		this.$el.find('.filterstittle').show()
		this.$el.find('#statsbtn').hide();
		location.href = "#charts";
		if(!permissions.accessallreports){
			$('#radiooption6').hide();
			$('#generalcharttittle').hide();
			var usersupercats = '';
			for (var i = 0; i < permissions.categories.length; i++) {
				usersupercats = usersupercats+permissions.categories[i]+',';
			}
			usersupercats = usersupercats.slice(0, -1);
			location.href = "#charts?supercategories"+usersupercats;
		}
	},
	
	changeradioopt: function(e){
		if(e.currentTarget.value == 'dias'){
			this.$el.find('#rangepicker').hide('fast');
			this.$el.find('#rangepicker2').hide('fast');
			setTimeout(function(){
				$('#rangepicker3').show();
			}, 50);
		}
		if(e.currentTarget.value == 'mes'){
			this.$el.find('#rangepicker3').hide('fast');
			this.$el.find('#rangepicker2').hide('fast');
			setTimeout(function(){
				$('#daypicker').val('');
				$('#rangepicker').show();
			}, 50);
		}
		if(e.currentTarget.value == 'year'){
			this.$el.find('#rangepicker3').hide('fast');
			this.$el.find('#rangepicker').hide('fast');
			setTimeout(function(){
				$('#rangepicker2').show();
			}, 50);
		}
	},
	
	changeradioopt2: function(e){
		if(e.currentTarget.value == 'categories'){
			this.$el.find('#catsandsubcatscontainer').hide('fast');
			setTimeout(function(){
				$('#catscontainer').show();
				$('#set').show();
			}, 50)
		}
		if(e.currentTarget.value == 'subcategories'){
			this.$el.find('#catscontainer').hide('fast');
			setTimeout(function(){
				$('#catsandsubcatscontainer').show();
				$('#set').show();
			}, 50)
		}
		if(e.currentTarget.value == 'generalopt'){
			this.$el.find('#catscontainer').hide('fast');
			this.$el.find('#catsandsubcatscontainer').hide('fast');
			setTimeout(function(){
				$('#set').show();
			}, 50)
		}
	},
	
	expandCollapse: function () {
		if ($('body').hasClass('nav-md')) {
			$('.sidebar').hide();
			$('.main_container .top_nav').css('margin-left','0px');
			// 	this.$sidebar.find('li.active').addClass('active-sm').removeClass('active');
		}
		else {
			$('.sidebar').css('display','flex');
			$('.main_container .top_nav').css('margin-left','230px');
			//this.$sidebar.find('li.active-sm').addClass('active').removeClass('active-sm');
		}
		$('body').toggleClass('nav-md');
	},
	
	sectionOpenClose: function (e) {
		var $li = $(e.currentTarget).parent();
		if ($li.is('.active')) {
			$li.removeClass('active active-sm');
			$('ul:first', $li).slideUp(function () {
				EventHub.trigger('app:refreshContentHeight');
			});
		}
		else {
			if (!$li.parent().is('.child_menu')) {
				this.$el.find('li').removeClass('active active-sm');
				this.$el.find('li ul').slideUp();
			}
			$li.parent().find('li').removeClass('current-page active active-sm');
			$li.addClass('current-page active');
			$('ul:first', $li).slideDown(function () {
				EventHub.trigger('app:refreshContentHeight');
			});
		}
	},
	
	render: function () {
		var self = this;
		if(Parse.User.current()){
			var templateFunc = Handlebars.template(template);
			var permissions = getUtilsService.getprofilepermissions();
			this.$el.html(templateFunc({
				user:Parse.User.current(),
				categories: [],
				supandsub: [],
				admin : Parse.User.current().attributes.role == 'admin',
				permissions : permissions
			}));
			if (permissions.reportcharts == false && permissions.usercharts == false) {
				$("#chartbtn").hide();
			}
			if(Settings.shogunmonitorapp && Parse.User.current().attributes.role != 'Administrador General'){
				$('#userstrazgraph').css('display','none');
			}
			this.translate();
			$('#listxa').hide();
			getReportCategoryService().fetch({
				all: true,
				cache: false
			}).then(data => {
				var templateFunc = Handlebars.template(template);
				var permissions = getUtilsService.getprofilepermissions();
				var user = Parse.User.current();
				getReportSubCategoryService().fetch({
					all: true,
					cache: false,
					includes: ['subCategory','subCategory.superCat','subCategory.superCat.name'],
					rules: {
						equals: [{
							key: 'active',
							val: true,
						}]
					}
				}).then(subcategory => {
					this.subCategories = subcategory.models;
					var supercategories = data.models;
					if (!permissions.accessallreports){
						supercategories = [];
						for(var i=0;i<data.models.length;++i){
							if(permissions.categories.includes(data.models[i].id)){
								supercategories.push(data.models[i]);
							}
						}
					}
					var supercatarray = [];
					for (var w = 0; w < supercategories.length; w++) {
						if (supercategories[w].attributes.active) {
							var supercatx = {};
							supercatx.subcat = [];
							supercatx.supercatname = supercategories[w].attributes.name;
							supercatx.supercatid = supercategories[w].id;
							for (var i = 0; i < this.subCategories.length; i++) {
								if (supercategories[w].id == this.subCategories[i].attributes.superCat.id  ) {
									supercatx.subcat.push(this.subCategories[i]);
								}
							}
							supercatarray[w] = supercatx;
						}
					}
					var supercatandsubcats = [];
					for (var i = 0; i < supercatarray.length; i++) {
						if(supercatarray[i]){
							supercatandsubcats.push(supercatarray[i]);
						}
					}
					this.varsupandsubs = supercatandsubcats;
					self.$el.html(templateFunc({
						user:Parse.User.current(),
						categories: supercategories,
						supandsub: supercatandsubcats,
						admin : Parse.User.current().attributes.role == 'admin',
						permissions : permissions
					}));
					if(self.menuId){
						EventHub.trigger('sidebarView:setMenu', self.menuId);
					}
					if (permissions.reportcharts == false && permissions.usercharts == false) {
						$("#chartbtn").hide();
					}
					if(Settings.shogunmonitorapp && Parse.User.current().attributes.role != 'Administrador General'){
						$('#userstrazgraph').css('display','none');
					}
					this.translate();
					$('#listxa').hide();
					self.$sidebar = self.$('#sidebar-menu');
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		}
		$('#myModal').hide();
		$('.modal-backdrop').hide();
		self.attachEvents();
	},
	
	resetState: function() {
		this.$sidebar.find('.current-page, .active').removeClass('current-page active');
	},
	
	setActive: function (currentUrl) {
		if (this.currentUrl != currentUrl && this.$sidebar) {
			this.currentUrl = currentUrl;
			var $anchors = this.$sidebar.find('a');
			var $matchedAnchor = $anchors.filter(function () {
				return $(this).attr('href') == currentUrl;
			});
			this.resetState();
			$matchedAnchor.parent('li').addClass('current-page').parents('ul').slideDown(function () {
				EventHub.trigger('app:refreshContentHeight');
			}).parent().addClass('active');
		}
	},

	setMenu: function (menuId) {
		switch(menuId){
			case 'dashboard_menu':
			default:
				this.menuId = 'dashboard_menu';
				$('#dashboard_menu').show();
				$('#guides_menu').hide();
				$('.sidebar').css("width", "");
				$('.navbar-right').show();
				$('.chat').show();
			break;
			case 'guides_menu':
				this.menuId = 'guides_menu';
				$('#guides_menu').show();
				$('#dashboard_menu').hide();
				$('.sidebar').css("width", "249px");
				$('.navbar-right').hide();
				$('.chat').hide();
			break;
		}
	},
	
	logout: function () {
		getUserService().logOut();
	},
	
	attachEvents:function(){
		this.listenTo(EventHub, 'sidebarView:setActive', this.setActive);
		this.listenTo(EventHub, 'sidebarView:expandcollapse', this.expandCollapse);
		this.listenTo(EventHub, 'login', () => this.onLogin());
		this.listenTo(EventHub, 'sidebarView:setMenu', this.setMenu);
	},
	
	onLogin: function () {
		this.render();
	},
});
export default SidebarView;
